
export const BACKEND_URL = 'https://recetarium-back.onrender.com';

export const CATEGORIES = [
    "Aperitivos",
    "Tapas y Pinchos",
    "Primeros",
    "Segundos",
    "Guarniciones",
    "Postres"
  ];

